<template>
  <div class="bg-white py-6 px-12 text-left">
    <p class="text-lg">{{ $t("商品评价") }}</p>
    <div v-if="orderList">
      <div
        v-for="item in orderList"
        :key="item.id"
        class="grid items-start w-25rem grid-cols-[5rem,auto,4rem] py-3"
      >
        <p class="w-4.5rem h-4.5rem">
          <img
            :src="$firstImage(item.images, 'small')"
            class="w-full h-full text-lg rounded img"
            :onerror="defaultUrl"
          />
        </p>
        <p>
          <span class="font-semibold text-base">{{ item.name }}</span>
        </p>
        <p class="text-right">
          <span class="block">{{ $p(item.price) }}</span>
          <span class="block text-gray-400">×{{ item.quantity }}</span>
        </p>
      </div>
    </div>
    <div>
      <div class="flex flex-nowrap rate mt-4 space-x-6">
        <span class="text-base pt-4">{{ $t("评分") }}</span>
        <el-rate
          v-model="commentData.score"
          show-text
          :texts="rateTexts"
        ></el-rate>
      </div>
      <ul class="roundCard">
        <li
          v-for="item in replyWords"
          :key="item.id"
          @click="selectWords(item.value)"
          class="cursor-pointer"
        >
          {{ item.value }}
        </li>
      </ul>
      <el-input
        type="textarea"
        :placeholder="$t('真实评价，帮助更多想买的人（5~500字')"
        v-model="commentData.content"
        maxlength="500"
        show-word-limit
        class=""
      ></el-input>
      <p class="text-xs text-gray-400 mb-4">{{ $t("上传图片（选填）") }}</p>
      <div class="flex space-x-4">
        <div
          class="w-5rem h-5rem flex-center bg-mainGray rounded-sm"
          @click="selectImg"
        >
          <span class="el-icon-camera text-2rem text-gray-400"></span>
        </div>
        <div class="flex space-x-4" v-if="imgUrl">
          <div
            class="w-5rem h-5rem choose_img relative show"
            v-for="(item, index) in imgUrl"
            :key="index"
          >
            <img :src="item" class="w-full h-full img" />
            <p
              class="
                absolute
                top-0
                right-0
                bg-mainHigh
                w-5
                h-5
                rounded-bl-md
                hidden
                del
                text-center
              "
              @click="del(index)"
            >
              <span
                class="iconfont icon-shanchu text-white text-xs pt-1"
              ></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <el-checkbox v-model="nameless" class="text-xs text-gray-400 block my-5">{{
      $t("匿名评价")
    }}</el-checkbox>

    <el-button type="primary" class="w-9.6rem" @click="confirm">{{
      $t("发布评价")
    }}</el-button>
  </div>
</template>
<script>
import { reactive, ref, onMounted } from "@vue/composition-api";
export default {
  setup(props, ctx) {
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';
    const orderId = ctx.root.$route.params.id;
    const rateTexts = [
      ctx.root.$t("极差"),
      ctx.root.$t("失望"),
      ctx.root.$t("一般"),
      ctx.root.$t("满意"),
      ctx.root.$t("非常满意"),
    ];
    const imgUrl = ref([]);
    //选择图片
    const selectImg = async () => {
      const res = await ctx.root.$chooseImages();
      imgUrl.value.push(res?.path);
    };
    //删除单个图片
    const del = (e) => {
      imgUrl.value.splice(e, 1);
    };
    //是否匿名
    const nameless = ref(false);
    const commentData = reactive({
      score: 5,
      content: "",
      images: null,
    });
    const formData = ref([]);
    const orderList = ref();
    const getFormData = () => {
      orderList.value.map((item) => {
        let obj = {};
        (obj.id = item.id), (obj.content = commentData.content);
        obj.images = commentData.images ? commentData.images : item.images;
        obj.score = commentData.score;
        formData.value.push(obj);
      });
    };
    //接受待评价订单信息

    //快捷输入语
    const replyWords = ref();
    onMounted(async () => {
      orderList.value = (
        await ctx.root.$callapi("user/getOrderDetail", { id: orderId })
      ).data.items;

      replyWords.value = (await ctx.root.$lazy("datadic")).replywords;
    });
    //点击快捷回复语添加到评论框
    const selectWords = (word) => {
      commentData.content = commentData.content + "#" + word + "#";
    };

    //发布评论
    const sendComment = async (query) => {
      const res = await ctx.root.$callapi("user/doForOrderAction", query);
      if (res.code == 0) {
        ctx.root.$toast(ctx.root.$t("发布成功"), "success");
        ctx.root.$router.go(-1);
      }
    };
    const confirm = async () => {
      if (imgUrl.value.length) {
        commentData.images = imgUrl.value.join(";");
        getFormData();
        let arr = [];
        for (let i of formData.value) {
          const res = await ctx.root.$autoUploads(i, ["images"]);
          arr.push(res);
        }
        const query = {
          action: "commenton",
          data: {
            logscore: commentData.score,
            serscore: commentData.score,
            nameless: nameless.value,
            items: arr,
          },
          ids: [orderId],
        };
        sendComment(query);
      } else {
        getFormData();
        const query = {
          action: "commenton",
          data: {
            logscore: commentData.score,
            serscore: commentData.score,
            nameless: nameless.value,
            items: formData.value,
          },
          ids: [orderId],
        };
        sendComment(query);
      }
    };

    return {
      rateTexts,
      nameless,
      imgUrl,
      selectImg,
      del,
      orderList,
      defaultUrl,
      confirm,
      commentData,
      replyWords,
      selectWords,
    };
  },
};
</script>
<style scoped lang="scss">.roundCard > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.25rem * var(--tw-space-x-reverse));
  margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.roundCard {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-top: 2.5rem;
}
.roundCard li {
  --tw-bg-opacity: 1;
  background-color: rgba(244, 244, 244, var(--tw-bg-opacity));
  border-radius: 1rem;
  height: 2rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
  padding-top: 0.35rem;
  padding-bottom: 0.35rem;
  --tw-text-opacity: 1;
  color: rgba(156, 163, 175, var(--tw-text-opacity));
  width: auto;
}
.rate ::v-deep .el-rate__icon {
  font-size: 2rem;
  line-height: 1;
}
.rate ::v-deep .el-rate__text {
  font-size: 0.75rem;
  line-height: 1rem;
  vertical-align: bottom;
  color: #909090 !important;
}
.el-textarea ::v-deep .el-textarea__inner {
  height: 9.5rem;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.show:hover .del {
  display: block;
}</style>
